
import { getValue, sortPosition } from '../../utils.js'

const SUB_GRAY = new Image()
SUB_GRAY.src = require('./images/sub-gray.png')

const SUB = new Image()
SUB.src = require('./images/sub.png')

const PLUS_GRAY = new Image()
PLUS_GRAY.src = require('./images/plus-gray.png')

const PLUS = new Image()
PLUS.src = require('./images/plus.png')

let levelCache = {}

let defaultLevel = -3

const cachePrefix = 'CanvasTextFlex'


function initCache() {
  let cache = localStorage.getItem(cachePrefix)
  if (cache) {
    levelCache = JSON.parse(cache)
  }
  // console.log('init', levelCache)
}

function getCacheKey (key, col) {
  if (levelCache[key] === 0) {
    return 0
  }
  if (levelCache.hasOwnProperty(key) && typeof levelCache[key] === 'number') {
    return levelCache[key]
  }
  const hasTextFlexMaxLevel = typeof col.TextFlexMaxLevel === 'number'
  const TextFlexMaxLevel = col.TextFlexMaxLevel
  const defaultTextFlexLevel = col.defaultTextFlexLevel
  if (col && typeof defaultTextFlexLevel === 'number') {
    return defaultTextFlexLevel >= 0 ? 0 : (hasTextFlexMaxLevel && defaultTextFlexLevel <= TextFlexMaxLevel ? TextFlexMaxLevel : defaultTextFlexLevel)
  }
  return hasTextFlexMaxLevel ? (defaultLevel <= TextFlexMaxLevel ? TextFlexMaxLevel : defaultLevel) : defaultLevel
}

initCache()

function render (ctx, { col, textCtx, text, x, y, sortCol, headerTipOptions }) {
  // 计算文字宽度
  let width = sortPosition(textCtx, text)

  // 列宽不够展示缩进/展开图标时，则不绘制
  // 2021-08-02 头部增加提示icon，增加宽度
  let headerWidth = (col.headerTip || headerTipOptions[col.key]) ? 8 : 0
  if (col.width < width + 62 + headerWidth) {
    return
  }

  let cacheKey = makeKey(this, col)
  let oldLevel = getCacheKey(cacheKey, col)
  // let oldLevel = levelCache[cacheKey]
  let maxLevel = extractMaxLevelFromRowData(this, col)
  let img1 = null
  let img2 = null
  // console.log(maxLevel)
  if (!maxLevel) {
    img1 = SUB_GRAY
    img2 = PLUS_GRAY
  } else {
    maxLevel = ~maxLevel + 2 // eg: 5 => -4; 9 => -8
    img1 = oldLevel <= maxLevel ? SUB_GRAY : SUB
    img2 = oldLevel >= 0 ? PLUS_GRAY : PLUS
  }
  col.TextFlexMaxLevel = maxLevel
  // 把缩进图标画到文字后面
  ctx.drawImage(img1, x + width + 16 + headerWidth, y - 5, 12, 12)
  ctx.drawImage(img2, x + width + 44 + headerWidth, y - 5, 12, 12)
}

function extractMaxLevelFromRowData(vm, col) {
  let key = col.key
  let delimiter = col.delimiter || '/'
  if (!vm.data || vm.data.length === 0) return 0
  try {
    let levels = vm.data.map(function(row) {
      let value = getValue(key, row)
      // 如果九级组织字段最后一个是以/结尾，则去除
      if (value && value[value.length - 1] === '/') {
        value = value.substr(0, value.length - 1)
      }
      return value ? value.split(delimiter).length : 0
    })
    return Math.max(...levels)
  } catch (e) {
    return 0
  }
}

function handleClick (e) {
  // 计算文字宽度
  let width = sortPosition(e.textCtx, e.col.label)
  // 减去横向滚动条滚动的距离，解决横向滚动后点击失效的bug
  let curX = e.col.x - e.disx + width + 16
  if (e.x < curX) {
    e.sortFunc()
  } else if (e.x > curX + 6 && e.x < curX + 18) {
    // 缩进
    deptIndent('-', this, e.col)
  } else if (e.x > curX + 34 && e.x < curX + 46) {
    // 复原
    deptIndent('+', this, e.col)
  }
}

export function getDeptIndent (vm, col) {
  let cacheKey = makeKey(vm, col)
  let oldLevel = getCacheKey(cacheKey, col)
  // let oldLevel = levelCache[cacheKey]
  return oldLevel <= col.TextFlexMaxLevel ? oldLevel : (oldLevel >= 0 ? 0 : oldLevel)
}

export function subPlusDeptIndet (type, col, oldLevel, cacheKey) {
  if (type === '-') {
    // 缩进
    console.log(col.TextFlexMaxLevel)
    let level = oldLevel <= col.TextFlexMaxLevel ? oldLevel : oldLevel - 1
    levelCache[cacheKey] = level
  } else if (type === '+') {
    // 复原
    let level = oldLevel >= 0 ? 0 : oldLevel + 1
    levelCache[cacheKey] = level
  }
}

export function setDeptIndent (col, val, vm) {
  let cacheKey = makeKey(vm, col)
  if (typeof val === 'number') {
    levelCache[cacheKey] = val
  }
  console.log('当前缩进::::', levelCache[cacheKey])
  setLocalStorage()
}

export function deptIndent (type, vm, col) {
  let cacheKey = makeKey(vm, col)
  let oldLevel = getCacheKey(cacheKey, col)
  subPlusDeptIndet(type, col, oldLevel, cacheKey)
  console.log('当前缩进::::', levelCache[cacheKey])
  setLocalStorage()
  vm.loadLocalData({
    cb: rows => rows
  })
}

function format (row, col, val) {
  // 九级组织字段如果是空则返回空字符串
  if (!val) {
    return ''
  }
  let cacheKey = makeKey(this, col)
  let delimiter = col.delimiter || '/'
  let level = getCacheKey(cacheKey, col)
  // let level = levelCache[cacheKey]
  if (!level && level !== 0) {
    level = 0
    levelCache[cacheKey] = 0
  }
  try {
    if (level >= 0) {
      return val
    } else {
      // 九级组织字段是否以/结尾
      let temp = val[val.length - 1] === '/'
      let arr = val.split(delimiter)
      if (temp) {
        arr.pop()
      }
      let currentLevel = arr.length > Math.abs(level) ? Math.abs(level) : arr.length - 1
      arr.splice(0, currentLevel)
      return temp ? arr.join(delimiter) + '/' : arr.join(delimiter)
    }
  } catch (e) {
    console.error('[TextFlexWidget format]: ', e)
    return val
  }
}

function setLocalStorage () {
  localStorage.setItem(cachePrefix, JSON.stringify(levelCache))
}

function makeKey (vm, col) {
  let path = vm.$route.path
  return path + col.key
}

export default {
  render,
  handleClick,
  format
}



// WEBPACK FOOTER //
// ./src/public/components/kye-canvas-table/widget/text-flex/index.js